// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"e0d9bbc9","940":"e0d9bbc9"}[chunkId] + ".chunk.css";
};